import { render, staticRenderFns } from "./app-sidemenu.vue?vue&type=template&id=b4e95258"
import script from "./app-sidemenu.vue?vue&type=script&lang=js"
export * from "./app-sidemenu.vue?vue&type=script&lang=js"
import style0 from "./app-sidemenu.vue?vue&type=style&index=0&id=b4e95258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports